import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { getTimeAgoShort } from "@/helpers/Helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface MemeWinnerArtistInfoProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo?: boolean | undefined;
}
export default function MemeWinnerArtistInfo(t0) {
  const $ = _c(27);
  const {
    drop,
    showWaveInfo: t1
  } = t0;
  const showWaveInfo = t1 === undefined ? true : t1;
  const decisionTime = drop.winning_context?.decision_time;
  let t2;
  if ($[0] !== drop) {
    t2 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== drop.author) {
    t3 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[2] = drop.author;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== drop.author) {
    t4 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><Link onClick={_temp} href={`/${drop.author?.handle}`} className="tw-no-underline desktop-hover:hover:tw-underline tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80 tw-transition tw-duration-300 tw-ease-out">{drop.author?.handle}</Link></UserProfileTooltipWrapper> : <Link onClick={_temp2} href={`/${drop.author?.handle ?? drop.author?.id}`} className="tw-no-underline desktop-hover:hover:tw-underline tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80 tw-transition tw-duration-300 tw-ease-out">{drop.author?.handle ?? drop.author?.id}</Link>}</p>;
    $[4] = drop.author;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== drop.created_at) {
    t6 = getTimeAgoShort(drop.created_at);
    $[7] = drop.created_at;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <p className="tw-text-xs tw-mb-0 tw-whitespace-nowrap tw-font-normal tw-leading-none tw-text-iron-500">{t6}</p>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2">{t3}{t4}{t5}{t7}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = decisionTime ?? null;
  let t10;
  if ($[15] !== t9) {
    t10 = <WinnerDropBadge rank={1} decisionTime={t9} />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== drop.wave || $[18] !== showWaveInfo) {
    t11 = showWaveInfo && drop.wave && <Link onClick={_temp3} href={`/waves?wave=${drop.wave.id}`} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    $[17] = drop.wave;
    $[18] = showWaveInfo;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t8) {
    t12 = <div className="tw-flex tw-flex-col tw-items-start tw-gap-y-2">{t8}{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t2) {
    t13 = <div className="tw-flex tw-items-start tw-gap-x-3">{t2}{t12}</div>;
    $[24] = t12;
    $[25] = t2;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}